import { Callout } from '@tallink/components-lib'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Layout from '../components/layout/Layout'
import s from './ErrorPage.module.scss'

export default function ErrorPage() {
  const { t } = useTranslation()

  return (
    <Layout pageTitle={t('errorPage.title')}>
      <div className={s.error}>
        <Callout
          body={
            <p
              dangerouslySetInnerHTML={{
                __html: t('errorPage.description')
              }}
            />
          }
          title={t('errorPage.title')}
          type="error"
        />
      </div>
    </Layout>
  )
}
